import type { SVGProps } from 'react'
const SvgSyChevronRight = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M8.5 4.25a.75.75 0 0 0-.531.219.75.75 0 0 0 0 1.062L14.438 12l-6.47 6.469a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.063 0l7-7a.75.75 0 0 0 0-1.062l-7-7A.75.75 0 0 0 8.5 4.25" />
	</svg>
)
export default SvgSyChevronRight
